import { SolucionPage } from "@/components/SolucionPage";
import { getSolucion } from "@/lib/soluciones";

export default function InboxUnificado() {
  const solucion = getSolucion("inbox-unificado")!;
  return <SolucionPage solucion={solucion} />;
}
